import {
  Avatar,
  Box,
  IconButton,
  Link,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import logo from "../../../assets/logo.png";
import avatar from "../../../assets/avatar.webp";
import { Link as LinkRouter, useNavigate } from "react-router-dom";
import { ItemMenuPc } from "./ItemMenuPc";
import { Cart, Search } from "../../../icons";
import { ItemOptionPc } from "./ItemOptionPc";
import {
  accessories,
  apparel,
  collections,
  discounts,
  footwear,
  trainingTools,
} from "../../../helpers/Const";
import { useCheckoutStore } from "../../../store/checkoutStore";

const getStyle = (theme: Theme) => {
  const boxMenuPc: SxProps<Theme> = {
    width: 1300,
    marginInline: 5,
    display: { xs: "none", md: "flex" },
    justifyContent: "space-between",
    gap: 5,
    alignItems: "center",
  };
  const boxItemPc: SxProps<Theme> = {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    gap: { md: 5, lg: 7 },
  };
  const boxMenu: SxProps<Theme> = {
    flex: 1,
    display: "flex",
    flexWrap: "wrap",
  };
  const content: SxProps<Theme> = {
    display: "flex",
    gap: 8,
    paddingInline: 8,
    paddingBottom: 5,
    paddingTop: 2,
  };
  const boxIcon: SxProps<Theme> = {
    flex: 1,
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 1,
  };
  const avatar: SxProps<Theme> = {
    width: 25,
    height: 25,
    border: `solid 2px ${theme.palette.primary[700]}`,
  };
  const title: SxProps<Theme> = {
    fontSize: 12,
    textTransform: "uppercase",
    fontWeight: 600,
    color: theme.palette.secondary.main,
  };
  return { boxMenuPc, boxMenu, content, boxItemPc, boxIcon, avatar, title };
};

export const HeaderPc = () => {
  const theme = useTheme();
  const styles = getStyle(theme);
  const navigate = useNavigate();

  const { variants } = useCheckoutStore();

  const onLogin = () => {
    window.location.href = "https://shopify.com/77095928084/account";
  };
  const onCheckout = () => {
    navigate("/checkout");
  };
  const onSearch = () => {
    navigate("/search");
  };

  return (
    <Box sx={styles.boxMenuPc}>
      <Box flex={1}>
        <Link component={LinkRouter} to="/">
          <img src={logo} loading="lazy" alt="logo" height={35} />
        </Link>
      </Box>

      <Box sx={styles.boxItemPc}>
        <ItemMenuPc label="Home" to="/" />
        <ItemMenuPc label="Store" to="/store" />
        <ItemMenuPc menulabel="Footwear">
          <Box sx={styles.boxMenu}>
            <Box sx={styles.content}>
              <Box display="flex" flexDirection="column">
                <Typography sx={styles.title} variant="overline">
                  footwear
                </Typography>
                {footwear.map((d) => (
                  <ItemOptionPc
                    key={d.id}
                    item={d.item}
                    to={`${d.to}/${d.toName}`}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </ItemMenuPc>

        <ItemMenuPc menulabel="Apparel">
          <Box sx={styles.boxMenu}>
            <Box sx={styles.content}>
              <Box display="flex" flexDirection="column">
                <Typography sx={styles.title} variant="overline">
                  Apparel
                </Typography>
                {apparel.map((d) => (
                  <ItemOptionPc
                    key={d.id}
                    item={d.item}
                    to={`${d.to}/${d.toName}`}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </ItemMenuPc>

        <ItemMenuPc menulabel="Collections">
          <Box sx={styles.boxMenu}>
            <Box sx={styles.content}>
              <Box display="flex" flexDirection="column">
                <Typography sx={styles.title} variant="overline">
                  Collections
                </Typography>
                {collections.map((d) => (
                  <ItemOptionPc
                    key={d.id}
                    item={d.item}
                    to={`${d.to}/${d.toName}`}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </ItemMenuPc>

        <ItemMenuPc menulabel="Accessories">
          <Box sx={styles.boxMenu}>
            <Box sx={styles.content}>
              <Box display="flex" flexDirection="column">
                <Typography sx={styles.title} variant="overline">
                  Accessories
                </Typography>
                {accessories.map((d) => (
                  <ItemOptionPc
                    key={d.id}
                    item={d.item}
                    to={`${d.to}/${d.toName}`}
                  />
                ))}
              </Box>

              <Box display="flex" flexDirection="column">
                <Typography sx={styles.title} variant="overline">
                  Training Tools
                </Typography>
                {trainingTools.map((d) => (
                  <ItemOptionPc
                    key={d.id}
                    item={d.item}
                    to={`${d.to}/${d.toName}`}
                  />
                ))}
              </Box>
            </Box>
          </Box>
        </ItemMenuPc>
           <ItemMenuPc menulabel="Discounts">
                <Box sx={styles.boxMenu}>
                  <Box sx={styles.content}>
                    <Box display="flex" flexDirection="column">
                      <Typography sx={styles.title} variant="overline">
                        Discounts
                      </Typography>
                      {discounts.map((d) => (
                        <ItemOptionPc
                          key={d.id}
                          item={d.item}
                          to={`${d.to}/${d.toName}`}
                        />
                      ))}
                    </Box>
                  </Box>
                </Box>
              </ItemMenuPc>

        <ItemMenuPc label="Contributors" to="/influencers" />
        <ItemMenuPc label="Catalogs" to="/catalog" />
        <ItemMenuPc label="Contact" to="/contact" />
      </Box>

      <Box sx={styles.boxIcon}>
        <IconButton onClick={onSearch}>
          <Search sx={{ width: 22, height: 22 }} />
        </IconButton>
        <IconButton onClick={onCheckout} sx={{ position: "relative" }}>
          <Box
            sx={{
              position: "absolute",
              right: -1,
              padding: "10px 6px",
              top: -4,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: "100vmax",
              backgroundColor: theme.palette.primary[500],
            }}
          >
            <Typography
              fontSize={10}
              fontWeight={600}
              lineHeight={0}
              color={theme.palette.common.white}
            >
              {variants.reduce((acc, q) => acc + q.qty, 0)}
            </Typography>
          </Box>

          <Cart sx={{ width: 22, height: 22 }} />
        </IconButton>
        <IconButton onClick={onLogin}>
          <Avatar src={avatar} alt="avatar" sx={styles.avatar} />
        </IconButton>
      </Box>
    </Box>
  );
};
